/* eslint-disable arrow-body-style */
export const toSrcSetString = imagesSet => {
  return (imagesSet && typeof imagesSet === 'object')
    ? Object.entries(imagesSet)
      .map(([size, path]) => `${path} ${size}w`)
      .join(', ')
    : '';
};

export const sklon = (qty, f1 = 'товар', f2 = 'товара', f3 = 'товаров') => {
  const m1 = qty % 10;
  const m2 = qty % 100;
  if (m2 >= 5 && m2 <= 20) return f3;
  if (m1 === 1) return f1;
  if (m1 >= 2 && m1 <= 4) return f2;
  return f3;
};

export const apxQtyText = quantityApxEn => {
  switch (quantityApxEn) {
    case ('many'):
      return 'много';
    case ('enough'):
      return 'достаточно';
    case ('little'):
      return 'мало';
    case ('none'):
      return 'нет';
    default:
      return 'Нет данных';
  }
};

export function throttle(func, ms) {
  let isThrottled = false,
    savedArgs,
    savedThis;

  function wrapper() {
    if (isThrottled) { // (2)
      savedArgs = arguments;
      savedThis = this;
      return;
    }

    func.apply(this, arguments); // (1)

    isThrottled = true;

    setTimeout(
      () => {
        isThrottled = false; // (3)
        if (savedArgs) {
          wrapper.apply(savedThis, savedArgs);
          savedArgs = savedThis = null;
        }
      },
      ms
    );
  }

  return wrapper;
}
